import { choiceQuery } from "components/scrapEyeDataDashboard/navigation/queryCodecs";
import { useNavigationQuery } from "components/scrapEyeDataDashboard/navigation/NavigationQueryProvider";
import { Box, Stack } from "@mui/material";
import { TitledTabs } from "components/common/titledTabs";
import { useTenantTranslation } from "hooks/formatters";
import { useState } from "react";
import { InstallationConfiguration } from "./InstallationConfiguration";
import { SensorTopologyPanel } from "./SensorTopologyPanel";
import { VideoPlayerGroupsSection } from "./VideoPlayerGroupsSection";
import { SensorRegistrySection } from "./SensorRegistrySection";
import { SensorConnectionsSection } from "./SensorConnectionsSection";
import { SensorInstallationsSection } from "./SensorInstallationsSection";

type InstallationTab = "topology" | "locations" | "players" | "records";

export const InstallationManagementTab = () => {
  const { t } = useTenantTranslation();
  const [tab, setTab] = useNavigationQuery(
    "installationTab",
    "topology",
    choiceQuery(["topology", "locations", "players", "records"] as const),
    "push"
  );
  const [visited, setVisited] = useState<InstallationTab[]>([tab]);
  const sections = [
    {
      key: "topology" as const,
      title: t("topologyConnectionsTimeline"),
      content: <SensorTopologyPanel />,
    },
    {
      key: "locations" as const,
      title: t("topologyLocationsPositions"),
      content: <InstallationConfiguration />,
    },
    {
      key: "players" as const,
      title: t("videoPlayerGroupsTitle"),
      content: <VideoPlayerGroupsSection />,
    },
    {
      key: "records" as const,
      title: t("topologySensorRecords"),
      content: (
        <Stack spacing={2}>
          <SensorRegistrySection />
          <SensorConnectionsSection />
          <SensorInstallationsSection />
        </Stack>
      ),
    },
  ];
  return (
    <Stack spacing={2} sx={{ p: 2 }}>
      <TitledTabs
        tabSpecs={sections.map((section) => ({ ...section, content: null }))}
        selectedTabKey={tab}
        onChange={(key) => {
          setTab(key);
          setVisited((previous) =>
            previous.includes(key) ? previous : [...previous, key]
          );
        }}
        tabsSx={{ overflowX: "auto", "& .MuiTabs-root": { flexShrink: 0 } }}
        containerSx={{ pb: 0 }}
      />
      {sections
        .filter(
          (section) => visited.includes(section.key) || section.key === tab
        )
        .map((section) => (
          <Box
            key={section.key}
            role="tabpanel"
            aria-label={section.title}
            hidden={tab !== section.key}
          >
            {section.content}
          </Box>
        ))}
    </Stack>
  );
};
